'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _validateValue = require('../enhancers/validateValue');

var _validateValue2 = _interopRequireDefault(_validateValue);

var _autoFocusWhenLoaded = require('../enhancers/autoFocusWhenLoaded');

var _autoFocusWhenLoaded2 = _interopRequireDefault(_autoFocusWhenLoaded);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  value: _propTypes.any,
  onChange: _propTypes.func.isRequired,
  schema: _propTypes.object,
  block: _propTypes.object
}), (0, _flattenDefaultProp2.default)('block'), (0, _flattenDefaultProp2.default)('schema'), (0, _withHandlers2.default)({
  onChange: function onChange(_ref) {
    var _onChange = _ref.onChange;
    return function (event) {
      return _onChange(event.target.checked);
    };
  }
}), _validateValue2.default, _autoFocusWhenLoaded2.default, (0, _exposeProps2.default)(['value', 'name', 'disabled', 'onChange', 'isInvalid', 'inputRef']));

var Checkbox = enhancer(_Checkbox2.default);
Checkbox.displayName = 'Checkbox';

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Checkbox/index.js
// module id = 1690
// module chunks = 0